// src/components/NavigationButtons/NavigationButtons.js

import React from "react";
import "./Polaroid.css";
import GustavusLogo from "assets/logos/gustavus_reg_mark_dark.svg";
import GIcon from "assets/icons/g_logo_frame.svg";

// TODO add these variables as props for reusability
let topLabel = "gustiebot.gustavus.edu";
let imageIcon = GIcon;
let logo = GustavusLogo;

const Polaroid = ({ image, sticker}) => {
  return (
    <div className="polaroid-container">
      <div
        //   TODO remove inline styles
        className="image-container"
      >
        <label>{topLabel}</label>
        <div className="photo-area">
          <img className="polaroid-image" src={image} alt="Generated" />
          <img className="icon" src={imageIcon} />
          <img style={{ width: "33%", float: "left" }} src={logo} />

          {sticker && sticker.src && (
            <img className="sticker" src={sticker.src} alt="Sticker" />
          )}
        </div>
      </div>
    </div>
  );
};

export default Polaroid;
